import {
  PATTERN_TOKEN_CODE_CLASSES,
  PATTERN_TOKEN_LIST_CLASSES,
  PATTERN_TOKEN_ROW_CLASSES,
  PATTERN_TOKEN_SAMPLE_CLASSES,
} from '../scalar.tokens';

import { type PatternTokenHelpProps } from './PatternTokenHelp.types';

/**
 * What each placeholder renders — the reference an operator writing a custom
 * format needs, with a live sample beside every token rather than a description
 * of one.
 *
 * Presentation only (U5).
 */
export function PatternTokenHelp({ title, rows }: PatternTokenHelpProps) {
  return (
    <div className={PATTERN_TOKEN_LIST_CLASSES}>
      <p className={PATTERN_TOKEN_SAMPLE_CLASSES}>{title}</p>
      <dl className={PATTERN_TOKEN_LIST_CLASSES}>
        {rows.map((row) => (
          <div key={row.token} className={PATTERN_TOKEN_ROW_CLASSES}>
            {/* A token is an identifier, so it is always LTR and monospaced —
                `DD/MM` reordered by the bidi algorithm is a different token. */}
            <dt dir="ltr" className={PATTERN_TOKEN_CODE_CLASSES}>
              {row.token}
            </dt>
            <dd className={PATTERN_TOKEN_SAMPLE_CLASSES}>
              {row.meaning} · {row.sample}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
